import React, { useState } from 'react'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import TakeAttendance from './Take_attendance/TakeAttendance';
import '../Student_attendance/Take_attendance/TakeAttendance.css'
import ViewReport from './View_report/ViewReport';

function StudentAttendance() {
    const [activeHeader, setActiveHeader] = useState("TakeAttendance");
    let [searchParams, setSearchParams] = useSearchParams({
        header: "",
    });
    const location = useLocation();
    const navigate = useNavigate();
    searchParams = new URLSearchParams(location.header);
    return (
        <div className="Total_container_CM me-3 ">
            <div className="mb-3 d-flex align-items-center justify-content-between flex-wrap">
                <div className="col-md-3 p-2 five_component_CM_Attendance ">
                    <button
                        className={` ${activeHeader === "TakeAttendance"
                            ? "cm_five_active_btn"
                            : "cm_five_btn"
                            }`}
                        onClick={(e) => {
                            setActiveHeader("TakeAttendance");
                            setSearchParams({ header: "TakeAttendance" });
                            localStorage.setItem("ActiveBtn", "TakeAttendance");
                        }}
                    >
                        Take Attendance
                    </button>
                    <button
                        className={` ${activeHeader === "ViewReport"
                            ? " cm_five_active_btn"
                            : "cm_five_btn"
                            }`}
                        onClick={(e) => {
                            setActiveHeader("ViewReport");
                            setSearchParams({ header: "ViewReport" });
                            localStorage.setItem("ActiveBtn", "ViewReport");
                        }}
                    >
                        View Report
                    </button>
                </div>
            </div>
            <div>
                {activeHeader === "TakeAttendance" && <TakeAttendance type='TAKE_ATTENDANCE' />}
                {activeHeader === "ViewReport" && <ViewReport type='VIEW_REPORT' />}
            </div>
        </div>
    )
}

export default StudentAttendance